import React from 'react';
import gql from 'graphql-tag';
import { useApolloClient } from '@apollo/client';
import { buildTranslateObject } from '../actions/mainActions';
import { LoadingMainApp } from '../UI';

export const TranslateProvider = React.createContext();


function getDefaultLanguage() {
	const languages = {
		es: 'es',
		ca: 'cat',
		en: 'en',
		gl: 'gal',
		pt: 'pt'
	};

	const languageCode = navigator.language || navigator.userLanguage;
	const language = languageCode.split('-')[0];
	return languages[language] ? languages[language] : 'en';
}


export const userLang = getDefaultLanguage();


export const getTranslations = gql`
	query getTranslations($language: String!) {
		translations(language: $language) {
			label
			text
		}
	}
`;

const TranslationsProvider = ({ children }) => {
	const [data, setData] = React.useState(null);
	const [loading, setLoading] = React.useState(true);
	const [language, setLanguage] = React.useState(userLang);
	const localTranslations = null;
	const client = useApolloClient();

	if (localTranslations) {
		if ((new Date().getTime() - JSON.parse(localTranslations)?.date) > 86400000) {
			sessionStorage.removeItem(language);
		}
	}

	const translations = React.useCallback(async () => {
		setLoading(true);
		const response = await client.query({
			query: getTranslations,
			variables: {
				language
			}
		});
		if (response.data) {
			setData(response.data);
			setLoading(false);
		}
	}, [client, setData, language, setLoading]);

	React.useEffect(() => {
		translations();
	}, [translations]);

	const changeLanguage = newLanguage => {
		setLanguage(newLanguage);
	};

	if (!data) {
		return <LoadingMainApp/>;
	}
	if (!localTranslations) {
		if (!loading && (data.translations === null || data.translations === undefined)) {
			return (
				<div style={{
					width: '100%',
					height: '100%',
					display: 'flex',
					// background: `url(${bg})`,
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
					backgroundPosition: 'center center',
					alignItems: 'center',
					justifyContent: 'center',
					overflowX: 'hidden'
				}}>
					{/* <Paper style={{
						width: isMobile ? '100%' : '60%',
						height: isMobile ? 'calc((100% - 3.5em) - 3.5em)' : '60%',
						maxWidth: "1000px",
						maxHeight: "570px",
						display: "flex",
						justifyContent: "center",
						alignItems: "center"
					}}> */}
						ERROR 500!
						Internal Server Error
					{/* </Paper> */}
				</div>
			);
		}

		const translationObject = buildTranslateObject(data.translations);
		sessionStorage.setItem(userLang, JSON.stringify(translationObject));
		return (
			<TranslateProvider.Provider value={{
				...translationObject,
				changeLanguage,
				currentLanguage: language,
			}} >
				{children}
			</TranslateProvider.Provider>
		);
	}
	const translate = localTranslations;
	return (
		<TranslateProvider.Provider value={{
			...translate,
			changeLanguage,
			currentLanguage: language,
		}} >
			{children}
		</TranslateProvider.Provider>
	);
};


export default TranslationsProvider;
